<template>
  <el-footer>
    <div class="foot-message">
      {{ configureInfos.content }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      {{ configureInfos.recordNo }}
    </div>
  </el-footer>
</template>

<script>
export default {
  data() {
    return {
      content: "",
      recordNo: ""
    }
  },
};
</script>

<style lang="scss" scoped>
.el-footer {
  width: 100%;
  height: 45px !important;
  line-height: 45px;
  text-align: center;
  position: relative;
  left: 0;
  bottom: 0;
  border-top: 1px solid #e9e9e9;
  font-size: 14px;

  >a {
    color: #333;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/comFooter.vue